import "core-js/modules/es6.string.link.js";
import "core-js/modules/es6.string.small.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "pricing-plan d-flex align-items-center flex-column bg-white"
  }, [_vm.header.length && _vm.header[0].text ? _c('h5', {
    staticClass: "header py-3 px-4 mb-0 text-center",
    style: {
      backgroundColor: _vm.headerBgColor
    }
  }, [_c('SimpleParagraph', {
    attrs: {
      "paragraph": _vm.header,
      "has-margin": false
    }
  })], 1) : _vm._e(), _vm._v(" "), _vm.image ? _c('div', {
    staticClass: "media"
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": _vm.image.small,
      "alt": _vm.image.alt,
      "data-sizes": "auto"
    }
  })]) : _vm._e(), _vm._v(" "), _vm.title ? _c('h5', {
    staticClass: "title font-weight-bold mt-3 mb-0 px-3 text-center"
  }, [_vm._v("\n    " + _vm._s(_vm.title) + "\n  ")]) : _vm._e(), _vm._v(" "), _vm.subtitleRich ? _c('SimpleParagraph', {
    staticClass: "subtitle mt-1 px-3 text-center",
    attrs: {
      "paragraph": _vm.subtitleRich
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "text-center pt-2 pb-1"
  }, [_vm.price ? _c('SimpleParagraph', {
    staticClass: "baseprice",
    attrs: {
      "paragraph": _vm.price
    }
  }) : _vm._e(), _vm._v(" "), _vm.subprice ? _c('div', {
    staticClass: "subprice",
    class: {
      strike: _vm.subpriceStrike
    }
  }, [_vm._v("\n      " + _vm._s(_vm.subprice) + "\n    ")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "separator my-3"
  }), _vm._v(" "), _vm.paragraphTitle.length || _vm.paragraph.length ? _c('div', {
    staticClass: "richtext flex-grow-1 text-left mb-4"
  }, [_vm.paragraphTitle.length ? _c('SimpleParagraph', {
    attrs: {
      "paragraph": _vm.paragraphTitle
    }
  }) : _vm._e(), _vm._v(" "), _vm.paragraph.length ? _c('SimpleParagraph', {
    attrs: {
      "paragraph": _vm.paragraph
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _vm.cta ? _c('a', {
    staticClass: "mb-4 cta",
    class: _vm.ctaClasses,
    attrs: {
      "href": _vm.link.url,
      "target": _vm.target
    },
    on: {
      "click": _vm.onClick
    }
  }, [_vm._v("\n    " + _vm._s(_vm.cta) + "\n  ")]) : _vm._e()], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };